export const handlePublishProgram = async ({
  publishDraftProgram,
  orgId,
  programId,
  wktIdsToDayIdcs,
  name,
  createAlert,
  updateProgram,
  reviewedLowConfWkts,
}) => {
  const { error } = await publishDraftProgram({
    orgId,
    programId,
    wktIdsToDayIdcs,
    name,
    reviewedLowConfWkts,
  })

  if (error) {
    createAlert({ text: 'Could not publish program. Please try again.', type: 'danger' })
    return { error }
  }

  await updateProgram({ coachOrgId: orgId, programId, program: { publishedAt: Date.now() } })
  createAlert({ text: 'Program published!', type: 'success' })

  return {}
}
